import { FORM_ERROR, ScenarioForm } from "app/scenarios/components/ScenarioForm"
import createScenario from "app/scenarios/mutations/createScenario"
import { useMutation, invalidateQuery } from "@blitzjs/rpc"
import { Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import * as Dialog from "@radix-ui/react-dialog"
import * as Portal from "@radix-ui/react-portal"
import React, { useContext } from "react"
import getScenarios from "app/scenarios/queries/getScenarios"
import { CreateScenario } from "app/validations"
import { CityContext } from "app/features/regional-map/regional-map.state"
import toast from "react-hot-toast"
import { scenarioIdEncode } from "app/utils/scenario_id"

export function ScenarioDialog({ close }: { close: () => void }) {
  const city = useContext(CityContext)!
  const router = useRouter()
  const [createScenarioMutation] = useMutation(createScenario)

  return (
    <Portal.Root>
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black bg-opacity-50 transition-all" />
      <Dialog.Content
        className="fixed left-1/2 top-20 z-10 -mx-48 w-96 rounded-md bg-white p-6 text-left shadow-lg"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex justify-between pb-2">
          <div className="text-lg font-semibold text-brand-green-dark">Create scenario</div>
        </div>
        <div>
          <ScenarioForm
            submitText="Create scenario"
            schema={CreateScenario}
            initialValues={{
              name: "",
              city: city.id.toUpperCase(),
            }}
            onSubmit={async (values) => {
              toast.dismiss()
              try {
                const scenario = await createScenarioMutation(values)
                await invalidateQuery(getScenarios)
                await router.push(
                  Routes.Map({ scenarioId: scenarioIdEncode(scenario.id), city: city.id })
                )
                close()
              } catch (error) {
                if ((error as Error)?.name === "ScenarioNameTakenError") {
                  return { [FORM_ERROR]: (error as Error).message }
                }
                return {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  [FORM_ERROR]: (error as any)?.toString(),
                }
              }
            }}
          />
        </div>
      </Dialog.Content>
    </Portal.Root>
  )
}
